import { Component, Input, Output, EventEmitter } from '@angular/core';

interface RequestDetail {
  id: string;
  status: string;
  projectName: string;
  projectId: string;
  workOrder: string;
  substation: string;
  region: string;
  county: string;
  totalMats: number;
  pm: {
    name: string;
    phone: string;
    email: string;
  };
  planner: {
    name: string;
    phone: string;
    email: string;
  };
  startDate: string;
  endDate: string;
  scopeOfWork: string;
}

@Component({
  selector: 'app-request-detail-modal',
  templateUrl: './request-detail-modal.component.html',
  styleUrls: ['./request-detail-modal.component.scss']
})
export class RequestDetailModalComponent {
  @Input() isVisible: boolean = false;
  @Input() requestData: RequestDetail | null = null;
  @Output() closeModal = new EventEmitter<void>();
  @Output() editRequest = new EventEmitter<RequestDetail>();

  activeTab: string = 'details';

  tabs = [
    { id: 'details', label: 'Details' },
    { id: 'allocation', label: 'Mat Allocation' },
    { id: 'timeline', label: 'Activity Timeline' },
    { id: 'documents', label: 'Files & Documents' }
  ];

  close(): void {
    this.closeModal.emit();
  }

  edit(): void {
    if (this.requestData) {
      this.editRequest.emit(this.requestData);
    }
  }

  setActiveTab(tabId: string): void {
    this.activeTab = tabId;
  }
}